import getDestination from "./other/get_destination.js";

const destination = getDestination();

export default {
    email: {
        topTitle: ajax_var.form_slides_settings.email.topTitle,
        fieldLabel: 'What’s your email?',
        placeholder: 'Email',
        fieldType: 'text',
        btnLabel: 'Next',
        pageBackground: 'email-background.jpg',
        next: 'name',
        prev: null
    },
    fullName: {
        topTitle: '',
        fieldLabel: 'What’s your name?',
        placeholder: 'Fullname',
        fieldType: 'text',
        btnLabel: 'Next',
        pageBackground: 'name-background.jpg',
        next: 'username',
        prev: 'email'
    },
    username: {
        topTitle: '',
        fieldLabel: 'Choose a username',
        placeholder: 'Username',
        fieldType: 'text',
        btnLabel: 'Next',
        pageBackground: 'username-background.jpg',
        next: 'password',
        prev: 'name'
    },
    password: {
        topTitle: '',
        fieldLabel: ajax_var.is_affiliate ? 'Choose your Hortisketch<br /> password' : 'Choose a password',
        fieldType: 'password',
        btnLabel: 'Next',
        placeholder: 'Your password',
        pageBackground: 'password-background.jpg',
        next: 'zipcode',
        prev: 'username'
    },
    signin: {
        topTitle: 'Oh hi! I see you already have an account',
        fieldLabel: ajax_var.is_affiliate ? 'Enter your Hortisketch<br /> password' : 'Enter your password',
        placeholder: ajax_var.is_affiliate ? 'Hortisketch password' : 'Password',
        fieldType: 'password',
        btnLabel: 'Sign In',
        pageBackground: 'existing-user-password-background.jpg',
        next: 'welcome',
        prev: 'email',
        //msge: `By checking this box you agree to be signed up to Garden Savvy's mailing list, which you can remove yourself from at any time`
    },
    forgot: {
        topTitle: 'Enter your email address and we’ll send you a link to reset your password.',
        fieldLabel: 'Password Reset',
        fieldType: 'text',
        btnLabel: 'Send',
        placeholder: 'Registered Email',
        pageBackground: 'existing-user-password-background.jpg',
        next: 'reset',
        prev: 'login'
    },
    reset: {
        topTitle: '',
        fieldLabel: 'Password Reset',
        fieldType: 'text',
        btnLabel: null,
        pageBackground: 'existing-user-password-background.jpg',
        next: null,
        prev: null
    },
    reset_password: {
        topTitle: '',
        fieldLabel: 'Reset Your Password',
        fieldType: 'password',
        placeholder: 'Your new password',
        btnLabel: 'Submit',
        pageBackground: 'existing-user-password-background.jpg',
        next: 'welcome',
        prev: null
    },
    zipcode: {
        topTitle: 'Let’s find your growing zone',
        fieldLabel: 'Enter your zipcode to find your growing zone',
        placeholder: 'Zipcode',
        fieldType: 'text',
        btnLabel: 'Sign Up',
        pageBackground: 'zipcode-background.jpg',
        next: 'welcome',
        prev: 'password',
        msge: `By checking this box you agree to be signed up to Garden Savvy's mailing list, which you can remove yourself from at any time`
    },
    welcome: {
        topTitle: 'Congrats, you’re in!',
        fieldLabel: 'Welcome to our community',
        btnLabel: 'Create your Garden & Get social',
        pageBackground: 'welcome-background.jpg',
        next: null,
        prev: 'finished'
    },
    video: {
        topTitle: 'New to Garden Savvy? Watch our Easy to Follow Tutorial Below!',
        pageBackground: '',
        next: null,
        prev: null
    },
    register: {
        topTitle: 'Create a ' + destination + ' account',
        fieldLabel: 'One account for all Garden Savvy products',
        fieldType: 'text',
        btnLabel: 'Submit',
        pageBackground: 'email-background.jpg',
        next: 'welcome',
        prev: null,
        //msge: `By checking this box you agree to be signed up to Garden Savvy's mailing list, which you can remove yourself from at any time`
    },
    login: {
        topTitle: 'Login to your ' + destination + ' account',
        fieldLabel: 'One account for all Garden Savvy products',
        fieldType: 'text',
        btnLabel: 'Submit',
        pageBackground: 'password-background.jpg',
        next: 'welcome',
        prev: null,
        //msge: `By checking this box you agree to be signed up to Garden Savvy's mailing list, which you can remove yourself from at any time`
    }
};
